import React from 'react';
import { SketchPicker } from 'react-color';
import withStyles from '@mui/styles/withStyles';

const styles = theme => ({
    mainDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        width:'100%',
        marginBottom:'10px',
        [theme.breakpoints.between('xs','md')]: {
            width:'100%'
		}
    },

    label:{
        color:'#000',
        fontWeight:'bold',
        textTransform:'capitalize',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize:'12px'
    },

    innDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        width:'180px',
        [theme.breakpoints.between('xs','md')]: {
            width:'173px'
        }
    },

    input:{
        display: 'block',
        padding: '5px 14px',
        fontSize: '1em',
        outline: 0,
        borderRadius: '4px',
        backgroundColor: '#F4F6F8',
        border:'1px solid #E5E5E5',
        width:'calc(100% - 45%)',
        [theme.breakpoints.between('xs','md')]: {
            padding: '10px 5px',
		}
    },

    colorBox:{
        display: 'block',
        padding: '5px 0px',
        fontSize: '1em',
        outline: 0,
        borderRadius: '4px',
        backgroundColor: 'red',
        border:'1px solid #E5E5E5',
        width:'45px',
        height:'25px'
    },
});

class ColorInput extends React.Component {
    _isMounted = false;
    constructor() {
        super();
        this.state ={
            displayColorPicker: false,
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    changeHandle = e => {
        this._isMounted = true;
        let value = e.hex;
        // let fieldName = e.target.id;
        if(this._isMounted) this.props.onChange(this.props.id,value);
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };
    
    handleClose = () => {
    this.setState({ displayColorPicker: false })
    };

    render() {
        let {title,classes,type,id,value,placeholder,font} = this.props;
        const popover = {
            position: 'absolute',
            zIndex: '2',
        }
        const cover = {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        }
    return(
        <div className={classes.mainDiv}>
            <span className={classes.label} style={{font}}>{title}</span>
            <div className={classes.innDiv}>
                <input 
                    type={type}
                    value={value}
                    id={id} 
                    placeholder={placeholder}
                    className={classes.input}
                    style={{font}}
                    readOnly
                    autoComplete='off || disabled'
                />
                <div className={classes.colorBox} onClick={this.handleClick} style={{background:value ? value : '#000'}}></div>
            </div>
            {this.state.displayColorPicker ? 
                <div style={ popover }>
                    <div style={ cover } onClick={ this.handleClose }/>
                    <SketchPicker onChangeComplete={this.changeHandle} color={value ? value : '#000'}/>
                </div>
            : null 
            }
        </div>
    )}
}

export default withStyles(styles)(ColorInput);